import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { ForgeImageUrls } from "../../forge-proxy/forge-proxy.module";
import { Subject } from "rxjs";

export interface IErrorRoutingState {
  backButtonEnabled?: boolean;
  graphicSrc?: string;
  message?: string;
  refreshButtonEnabled?: boolean,
  title?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorPageService {

  static get InternalServerError(): IErrorRoutingState {
    return {
      backButtonEnabled: false,
      graphicSrc: ForgeImageUrls.Error500,
      message: 'An internal error occurred. We suggest you pull over and contact your system administrator.',
      refreshButtonEnabled: true,
      title: `Oops, something went wrong!`
    };
  }

  static get NotFound(): IErrorRoutingState {
    return {
      backButtonEnabled: true,
      graphicSrc: ForgeImageUrls.Error404,
      message: `Even our best explorer couldn't find the page you're looking for. It might have been removed or you may have mistyped the URL.`,
      refreshButtonEnabled: false,
      title: `Nothing but tumbleweeds here...`
    };
  }

  static get Offline(): IErrorRoutingState {
    return {
      backButtonEnabled: false,
      graphicSrc: ForgeImageUrls.OfflineError,
      message: 'Check your internet connection and refresh the page.',
      refreshButtonEnabled: true,
      title: `Looks like you're off the grid.`
    };
  }

  static get UnAuthorized(): IErrorRoutingState {
    return {
      backButtonEnabled: true,
      graphicSrc: ForgeImageUrls.Error403,
      message: 'Your login is not authorized for this area. Contact your system administrator for access.',
      refreshButtonEnabled: false,
      title: `Hey, you're not supposed to be in here!`
    };
  }

  static get TooManyRequests(): IErrorRoutingState {
    return {
      backButtonEnabled: false,
      graphicSrc: ForgeImageUrls.Error500,
      message: 'Unusual activity was detected. Please wait a moment, then refresh the page. If prompted, complete the verification to continue.',
      refreshButtonEnabled: true,
      title: `Let's slow down for a second`
    };
  }

  public readonly showErrorPageSubject: Subject<IErrorRoutingState> = new Subject<IErrorRoutingState>();

  constructor(private router: Router) { }

  public async navigateToErrorPage(state?: IErrorRoutingState) : Promise<boolean> {
    return await this.router.navigate(['error'], { state: state });
  }

  public showErrorPage(state: IErrorRoutingState) {
    this.showErrorPageSubject.next(state);
  }
}